import * as React from 'react';
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as Site from '../../shared/Site';
import { Translate } from '../../shared/LanguageService';
import { CapitalizeFirstLetter } from '../../components/common/TextHelpers';
import { IPrintEvent } from './Types';

const blockedEventType = 4;

const columnWidths = ['13%', '10%', '10%', '19%', '15%', '33%'];

type PhotographerCalendarPrintEventsTableProps = {
    dates: string[];
    eventsPerDay: { [date: string]: IPrintEvent[] };
};

const tableStyle = {
    tableLayout: 'fixed',
    '& th, & td': { paddingX: 1 },
    '& td': { overflowWrap: 'anywhere' },
    '& thead th': { lineHeight: 1.3, verticalAlign: 'bottom' },
    '& tr.se360 > td:first-of-type': {
        borderLeft: '6px solid',
        borderLeftColor: 'primary.main'
    },
    '& tr.scandphotos > td:first-of-type': {
        borderLeft: '6px solid',
        borderLeftColor: 'warning.main'
    },
    '& tr[data-blocked="true"] td': {
        color: 'text.secondary',
        fontStyle: 'italic'
    }
};

function header(key: string) {
    return Translate(`photographercalendar/printevents/modal/body/table/header/${key}`);
}

function dayHeading(date: string) {
    return CapitalizeFirstLetter(moment(date, 'YYYYMMDD').format('dddd D MMMM'));
}

export function PhotographerCalendarPrintEventsTable({
    dates,
    eventsPerDay
}: PhotographerCalendarPrintEventsTableProps) {
    let daysWithEvents = dates.filter((date) => (eventsPerDay[date] || []).length > 0);

    return (
        <Table size="small" stickyHeader sx={tableStyle}>
            <colgroup>
                {columnWidths.map((width, index) => (
                    <col key={index} style={{ width }} />
                ))}
            </colgroup>
            <TableHead>
                <TableRow>
                    <TableCell>{header('ordernumber')}</TableCell>
                    <TableCell>{header('start')}</TableCell>
                    <TableCell>{header('end')}</TableCell>
                    <TableCell>{header('package')}</TableCell>
                    <TableCell align="right">{header('numberOfimages')}</TableCell>
                    <TableCell>{header('adress')}</TableCell>
                </TableRow>
            </TableHead>
            {daysWithEvents.map((date) => (
                <TableBody key={date}>
                    <TableRow>
                        <TableCell
                            colSpan={columnWidths.length}
                            sx={{ backgroundColor: 'grey.100', fontWeight: 'bold' }}
                        >
                            {dayHeading(date)}
                        </TableCell>
                    </TableRow>
                    {eventsPerDay[date].map((item) => (
                        <TableRow
                            key={item.id}
                            hover
                            className={Site.getOrderCssClass(item.site)}
                            data-blocked={item.type === blockedEventType ? 'true' : undefined}
                        >
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                {item.type !== blockedEventType && item.orderNumber}
                            </TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                {moment(item.start).format('LT')}
                            </TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                {moment(item.end).format('LT')}
                            </TableCell>
                            <TableCell>{item.title}</TableCell>
                            <TableCell align="right">{item.numberOfImages}</TableCell>
                            <TableCell>{item.description}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            ))}
        </Table>
    );
}
